module.exports = __webpack_public_path__ + "static/media/splogoalpha.6d783034.png";